import { CONFIG } from './config';

export const STATIC = CONFIG.APP_URL + '/images/';

const CLIPARTS = STATIC + 'cliparts/';
const SAMPLES = CONFIG.APP_URL + '/samples/';

export const RESOURCES = {
  LOGO: STATIC + 'logo.png',
  USER: STATIC + 'user.png',
  BUSINESS: STATIC + 'business.png',
  GROUP: STATIC + 'group.png',
  PLAY_STORE: STATIC + 'google-play-store.png',
  MESSAGING: CLIPARTS + 'messaging.png',
  COUPLE: CLIPARTS + 'couple.png',
  ANALYTICS: CLIPARTS + 'analytics.svg',
  BALOONS: CLIPARTS + 'baloons.svg',
  BROWSING: CLIPARTS + 'browsing.svg',
  ERROR: CLIPARTS + 'error.svg',
  FUN: CLIPARTS + 'fun.svg',
  GIRL: CLIPARTS + 'girl.svg',
  KIDS: CLIPARTS + 'kids.svg',
  LEAVE: CLIPARTS + 'leave.svg',
  PARTY: CLIPARTS + 'party.svg',
  PERSON: CLIPARTS + 'person.svg',
  SHOPING: CLIPARTS + 'shoping.svg',
  TEAM: CLIPARTS + 'team.svg',
  ROOM_EMPTY: CLIPARTS + 'room-empty.png',
  VIDEO_CALL: CLIPARTS + 'video-call.png',
  WAITING: CLIPARTS + 'waiting.png',
  WORK: CLIPARTS + 'work.svg',

  ASSETS_SAMPLE: SAMPLES + 'assets-sample.xlsx',
  CLIENTS_SAMPLE: SAMPLES + 'clients-sample.xlsx',
  VENDORS_SAMPLE: SAMPLES + 'vendors-sample.xlsx',
  USERS_SAMPLE: SAMPLES + 'users-sample.xlsx',

  WORK_ANIVERSARY: STATIC + 'work-aniversary.png',
  WORK_BIRTHDAY: STATIC + 'work-birthday.png',
  WORK_WELCOME: STATIC + 'work-welcome.png'
};
